import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
};

export const UserSlice = createSlice({
  name: "UserSlice",
  initialState,
  reducers: {
    setUser: (state, { payload }) => {
      state.user = payload;
    },
    // setAddUser: (state, { payload }) => {
    //   state.jobs?.jobs.push(payload);
    // },
    // setDeleteUser: (state, { payload }) => {
    //   console.log(payload, "@User delete payload");
    //   const updatedUsers = state.user?.filter(
    //     (user) => user._id !== payload._id
    //   );
    //   state.user = updatedUsers;
    // },
  },
});

export const { setUser, setDeleteUser, setAddUser } = UserSlice.actions;
export default UserSlice.reducer;
